import './header.css';

export default (element,data) => {
  const { layout } = data;
  const header = element.querySelector('[data-header-container]');
  const isHeaderTransparent = element.querySelector('[data-header-container-transparent]');
  const headerWrapper = header.querySelector('[data-header-wrapper]');
  const HeaderLightCopy = headerWrapper.classList.contains('text-white');
  const headerLogo = header.querySelector('[data-header-logo]');
  const headerStickyLogo = header.querySelector('[data-header-sticky-logo]');
  const headerSearch = header.querySelector('[data-header-search]');
  const headerSearchContainer = header.querySelector('[data-header-search-container]');
  const headerSearchTrigger = header.querySelector('[data-header-search-trigger]');
  const body = document.querySelector('body');
  const megaMenus = element.querySelectorAll('[data-header-mega-menu]');
  const mobileLinks = element.querySelectorAll('[data-header-link]');

  const applyNegativeMargine = () => {
    if(isHeaderTransparent){
      const mainContent = document.querySelector('#MainContent');
      const firstSection = mainContent.querySelector('section');
      const firstSectionDiv = firstSection?.querySelector('div');
      mainContent?.classList.add('-mt-30')
      firstSectionDiv?.classList.add('pt-30');
    }
  }

  const updateHeaderStyles = () => {
    const { scrollY } = window;
    const currentURL = window.location.href;
    const wordToCheck = "collections";
   

    const secondWordToCheck = "products";
    const combinedRegex = new RegExp(`\\b(${wordToCheck}|${secondWordToCheck})\\b`, "i");

    if (combinedRegex.test(currentURL)) {
      const headerParentSection = document.querySelector('.header');
      if (headerParentSection) { 
        headerParentSection.classList.remove('sticky');
      }
    }

    if (isHeaderTransparent) {
      if (scrollY > 0) {
        header?.classList.add('transition-colors', 'duration-300', 'bg-white');
        header?.classList.remove('custom-gradient-background');
        headerLogo?.classList.remove('opacity-100');
        headerLogo?.classList.add('opacity-0');
        headerStickyLogo?.classList.remove('opacity-0');
        headerStickyLogo?.classList.add('opacity-100');
        headerWrapper?.classList.add('pb-0');
        if (layout.isAboveBreakpoint('lg')){
          headerSearch?.classList.remove('opacity-100');
          headerSearch?.classList.add('opacity-0');
          headerWrapper?.classList.add('lg:pb-0');
        } else {
          headerSearchContainer?.classList.remove('opacity-100');
          headerSearchContainer?.classList.add('opacity-0');
          headerSearchContainer?.classList.remove('bottom-5');
          headerSearchContainer?.classList.add('-top-10');
          headerSearchTrigger?.classList.add('opacity-100');
          headerSearchTrigger?.classList.remove('opacity-0');
          header?.classList.remove('pb-8');
        }
        updateChildElementsClasses(header, 'text-white', 'text-primary');
        updateChildElementsClasses(header, 'button--primary-small-inverse', 'button-revert');
        updateChildElementsClasses(header, 'border-white', 'border-primary');
      } else if (scrollY === 0) {
      
          header?.classList.remove('bg-white');
          header?.classList.add('custom-gradient-background');
          headerLogo?.classList.remove('opacity-0');
          headerLogo?.classList.add('opacity-100');
          headerStickyLogo?.classList.remove('opacity-100');
          headerStickyLogo?.classList.add('opacity-0');
          headerWrapper?.classList.remove('pb-0');
          if (layout.isAboveBreakpoint('lg')){
            headerSearch?.classList.add('opacity-100');
            headerSearch?.classList.remove('opacity-0');
            headerWrapper?.classList.remove('lg:pb-0');
          } else { 
            headerSearchContainer?.classList.add('opacity-100');
            headerSearchContainer?.classList.remove('opacity-0');
            headerSearchContainer?.classList.add('bottom-5');
            headerSearchContainer?.classList.remove('-top-10');
            headerSearchTrigger?.classList.add('opacity-0');
            headerSearchTrigger?.classList.remove('opacity-100');
            header?.classList.add('pb-8');
          }
        if (HeaderLightCopy) {
          updateChildElementsClasses(header, 'text-primary', 'text-white');
          updateChildElementsClasses(header, 'button-revert', 'button--primary-small-inverse');
          updateChildElementsClasses(header, 'border-primary', 'border-white');
        }
      }
    } else if (scrollY > 0) {
    
      headerLogo?.classList.remove('opacity-100');
      headerLogo?.classList.add('opacity-0');
      headerStickyLogo?.classList.remove('opacity-0');
      headerStickyLogo?.classList.add('opacity-100');
      headerWrapper?.classList.add('pb-0');
      header?.classList.add('!bg-white','!bg-none');
      if (HeaderLightCopy) {
        updateChildElementsClasses(header, 'text-white', 'text-primary');
        updateChildElementsClasses(header, 'button--primary-small-inverse', 'button-revert');
        updateChildElementsClasses(header, 'border-white', 'border-primary');
        }

      if (layout.isAboveBreakpoint('lg')){
        headerSearch?.classList.remove('opacity-100');
        headerSearch?.classList.add('opacity-0');
        headerWrapper?.classList.add('lg:pb-0');
      } else {
        headerSearchContainer?.classList.remove('opacity-100');
        headerSearchContainer?.classList.add('opacity-0');
        header?.classList.remove('pb-8');
      }
    } else if (scrollY === 0) {
    
      headerLogo?.classList.remove('opacity-0');
      headerLogo?.classList.add('opacity-100');
      headerStickyLogo?.classList.remove('opacity-100');
      headerStickyLogo?.classList.add('opacity-0'); 
      headerWrapper?.classList.remove('pb-0'); 
      header?.classList.remove('!bg-white','!bg-none');
      if (HeaderLightCopy) {
        updateChildElementsClasses(header, 'text-primary', 'text-white');
        updateChildElementsClasses(header, 'button-revert', 'button--primary-small-inverse');
        updateChildElementsClasses(header, 'border-primary', 'border-white');
      }

      if (layout.isAboveBreakpoint('lg')){
        headerSearch?.classList.add('opacity-100');
        headerSearch?.classList.remove('opacity-0');
        headerWrapper?.classList.remove('lg:pb-0');
      } else {
        headerSearchContainer?.classList.add('opacity-100');
        headerSearchContainer?.classList.remove('opacity-0');
        header?.classList.add('pb-8');
      }
    }
  };

  const updateChildElementsClasses = (parentElement, fromClass, toClass) => {
    const childElements = parentElement.querySelectorAll('*');
    const account = parentElement.querySelector('[data-header-account]')
    childElements.forEach((e) => {
      const parentWithMegaMenu = e.closest('[data-header-mega-menu]');
      if (!parentWithMegaMenu) {
        if(e !== account){
          if (e.classList.contains(fromClass)) {
            e.classList.remove(fromClass);
            if (toClass !== '') {
              e.classList.add(toClass);
            }
          }
        }
      }
    });
  };

  const hideAllMenus = () => {
    const hoverElements = element.querySelectorAll('[data-header-dot]')
    megaMenus.forEach((megaMenu) => {
      megaMenu.classList.remove('lg:opacity-100');
      megaMenu.classList.add('lg:opacity-0');
    });

    hoverElements.forEach((hoverElement) => {
      hoverElement.classList.remove('lg:opacity-100');
      hoverElement.classList.add('lg:opacity-0');
    })
  };

  const initMegaMenus = () => {
    if(layout.isAboveBreakpoint('lg')){
      const links = header.querySelectorAll('[data-header-link]');
      const linksContainer = header.querySelector('[data-header-links-container]');

      links.forEach((link) => {
        link.addEventListener('mouseover', () => {
          const { scrollY } = window;
          const hoverElement = link.querySelector('[data-header-dot]');
          hoverElement.classList.add('lg:opacity-100');
          hoverElement.classList.remove('lg:opacity-0');
          if(isHeaderTransparent){
            setTimeout(() => {
              header?.classList.add('transition-colors', 'duration-300', 'bg-white');
              header?.classList.remove('custom-gradient-background');
              updateChildElementsClasses(header, 'text-white', 'text-primary');
              updateChildElementsClasses(header, 'hover:text-white', 'hover:text-primary');
              updateChildElementsClasses(header, 'button--primary-small-inverse', 'button-revert');
              updateChildElementsClasses(header, 'border-white', 'border-primary');
            }, 10)
          }
          megaMenus.forEach((menu) => {
            const linkParent = link.dataset.headerLink;
            const megaParent = menu.dataset.parentLink;
            if (linkParent === megaParent) {
              hideAllMenus();
              setTimeout(() => {
                hoverElement.classList.add('lg:opacity-100');
                hoverElement.classList.remove('lg:opacity-0');
                menu.classList.remove('lg:opacity-0');
                menu.classList.add('lg:opacity-100');
                menu.classList.remove('lg:pointer-events-none');
                menu.classList.add('lg:pointer-events-auto');
                menu.addEventListener('mouseleave', () => {
                  menu.classList.add('lg:opacity-0');
                  menu.classList.remove('lg:opacity-100');
                  hoverElement.classList.add('lg:opacity-0');
                  hoverElement.classList.remove('lg:opacity-100');
                  menu.classList.add('lg:pointer-events-none');
                  menu.classList.remove('lg:pointer-events-auto');
                  if(HeaderLightCopy){
                    updateChildElementsClasses(header, 'text-primary', 'text-white');
                    updateChildElementsClasses(header, 'hover:text-primary', 'hover:text-white');
                    updateChildElementsClasses(header, 'button-revert', 'button--primary-small-inverse');
                    updateChildElementsClasses(header, 'border-primary', 'border-white');
                  } 
                  if(isHeaderTransparent && scrollY === 0){
                    header?.classList.remove('bg-white');
                    header?.classList.add('custom-gradient-background');
                  } else if(isHeaderTransparent && scrollY > 0){
                    header?.classList.add('bg-white')
                    header?.classList.remove('custom-gradient-background');
                    updateChildElementsClasses(header, 'text-white', 'text-primary');
                    updateChildElementsClasses(header, 'hover:text-white', 'hover:text-primary');
                    updateChildElementsClasses(header, 'button--primary-small-inverse', 'button-revert');
                    updateChildElementsClasses(header, 'border-white', 'border-primary');
                  }
                });
              }, 10)
              
              link.addEventListener('mouseleave', (event) => {
                if (
                  event.relatedTarget.dataset.parentLink !==
                  linkParent && event.relatedTarget !== linksContainer
                ) {
                  hideAllMenus();
                  if(scrollY === 0 && HeaderLightCopy){
                    updateChildElementsClasses(header, 'text-primary', 'text-white');
                    updateChildElementsClasses(header, 'hover:text-primary', 'hover:text-white');
                    updateChildElementsClasses(header, 'button-revert', 'button--primary-small-inverse');
                    updateChildElementsClasses(header, 'border-primary', 'border-white');
                  }
                  hoverElement.classList.add('lg:opacity-0');
                  hoverElement.classList.remove('lg:opacity-100');
                  menu.classList.add('lg:pointer-events-none');
                  menu.classList.remove('lg:pointer-events-auto');
                  if(isHeaderTransparent && scrollY > 0){
                    header.classList.add('bg-white')
                    if(HeaderLightCopy){
                      updateChildElementsClasses(header, 'text-white', 'text-primary');
                      updateChildElementsClasses(header, 'hover:text-white', 'hover:text-primary');
                      updateChildElementsClasses(header, 'button--primary-small-inverse', 'button-revert');
                      updateChildElementsClasses(header, 'border-white', 'border-primary');
                    }
                  }
                  else if(isHeaderTransparent){
                    header?.classList.remove('bg-white');
                    header?.classList.add('custom-gradient-background')
                  } 
                }
              }); 
            } else {
              hideAllMenus();
              hoverElement.classList.remove('lg:opacity-100');
              hoverElement.classList.add('lg:opacity-0');
              menu.classList.add('lg:pointer-events-none');
              menu.classList.remove('lg:pointer-events-auto');
              if(scrollY > 0 && isHeaderTransparent){
                header.classList.add("bg-white");
                if(HeaderLightCopy){
                  updateChildElementsClasses(header, 'text-white', 'text-primary');
                  updateChildElementsClasses(header, 'hover:text-white', 'hover:text-primary');
                  updateChildElementsClasses(header, 'button--primary-small-inverse', 'button-revert');
                  updateChildElementsClasses(header, 'border-white', 'border-primary');
                }
              }
            }
          });
        });
      });
    }
  };

  const initHamburgerMenu = () => {
    const hamburgerMenu = element.querySelector('[data-hamburger-menu]')
    const hamburgerLinks = element.querySelector('[data-header-links-wrapper]')
    const hamburgerMenuClose = element.querySelector('[data-header-close]')
    const headerLinks = element.querySelectorAll('[data-header-link]');

    hamburgerMenu.addEventListener('click', () => {
      body.classList.add('overflow-hidden');
      hamburgerMenu.classList.remove('z-10');
      hamburgerLinks.classList.add('translate-x-full');
      hamburgerLinks.classList.remove('translate-x-0');
      headerLinks.forEach((link) => {
        link.classList.remove(...['text-white','hover:text-white']);
        link.classList.add(...['text-primary', 'hover:text-primary']);
      })
      const contactUsButton = document.querySelector('[data-header-contact-us]');
      const accordion = document.querySelector('[data-header-contact-us-accordion]');
      const arrow = document.querySelector('[data-header-arrow-down]');

      let isOpen = false;

      contactUsButton?.addEventListener('click', () => {
        isOpen = !isOpen;

        if (isOpen) {
          accordion.style.maxHeight = `${accordion.scrollHeight}px`;
          accordion.classList.add('mb-8');
          contactUsButton.classList.remove('pb-8')
          contactUsButton.classList.add('pb-6');
          arrow.classList.add('rotate-180');
        } else {
          accordion.style.maxHeight = '0';
          accordion.classList.remove('mb-8');
          contactUsButton.classList.add('pb-8')
          contactUsButton.classList.remove('pb-6');
          arrow.classList.remove('rotate-180');
        }
      });
    })

    hamburgerMenuClose.addEventListener('click', () => {
      hamburgerMenu.classList.add('z-10');
      hamburgerLinks.classList.add('translate-x-0');
      hamburgerLinks.classList.remove('translate-x-full');
      body.classList.remove('overflow-hidden');
    })
  }

  const removeLinksOnMobile = () => {
    if (!layout.isAboveBreakpoint('lg')) {
      mobileLinks.forEach((link) => {
        if (link.dataset.hasSubmenu === "true") {
          link.removeAttribute('href');
        }
      });
    }
  };

  removeLinksOnMobile();

  const initMobileMegaMenus = () => {
    mobileLinks.forEach((link) => {
      link.addEventListener('click', () => {
        const linkParent = link.dataset.headerLink;
        megaMenus.forEach((menu) => {
          const megaParent = menu.dataset.parentLink;
          if (linkParent === megaParent) {
            body.classList.add('overflow-hidden');
            menu.classList.add('translate-x-full');
            menu.classList.remove('translate-x-0');

            const menuTitle = menu.querySelector('[data-header-mega-menu-mobile-title]')
            menuTitle.addEventListener('click', () => {
              menu.classList.remove('translate-x-full');
              menu.classList.add('translate-x-0');
            })
          }
        })
      })
    })

    const accordionItems = element.querySelectorAll('[data-header-submenu-toggle]');
    accordionItems?.forEach((accordion) => {
      const accordionToggleItem = accordion?.querySelector('[data-header-submenu-toggle-item]');
      const accordionContent = accordion?.querySelector('[data-header-submenu-toggle-content]');
      accordionToggleItem?.addEventListener('click', () => {
        const arrowIcon = accordionToggleItem.querySelector('span');
        if(accordion.classList.contains('toggle-active')){
          accordionContent.style.maxHeight = 
          `${accordionContent.scrollHeight}px`;
          setTimeout(() => {
            accordion.classList.remove('toggle-active');
            accordionContent.style.maxHeight = '0';
            accordion.classList.remove('pb-8');
            arrowIcon.classList.remove('rotate-180');
            setTimeout(() => {
              accordionToggleItem.classList.remove('pb-2');
            }, 250)
          }, 50);
        } else {
          accordion.classList.add('pb-8');
          accordionToggleItem.classList.add('pb-2');
          accordion.classList.add('toggle-active');
          accordionContent.style.maxHeight = 
          `${accordionContent.scrollHeight}px`;
          arrowIcon.classList.add('rotate-180');
          if(!arrowIcon.classList.contains('rotate-180')){
            arrowIcon.classList.add('rotate-180');
          }
        }
      })
    })
  }

  updateHeaderStyles();
  applyNegativeMargine();
  initMegaMenus();
  initHamburgerMenu();
  initMobileMegaMenus();

  window.addEventListener('scroll', updateHeaderStyles);
};
